import AnalyticsTable from "./AnalyticsTable";
import AuthWrapper from "./AuthWrapper";

//import { studentLayout, attemptLayout, studentData, attemptData } from "./DATA";

function App() {
	return (
		<AuthWrapper>
			<AnalyticsTable></AnalyticsTable>
		</AuthWrapper>
	);
}

export default App;
